import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format timestamp:
 * - Today: "3:11 PM"
 * - Same year: "Dec 9, 3:11 PM"
 * - Different year: "Dec 9, 2024, 3:11 PM"
 */
export function formatTimestamp(timestamp: Date): string {
  const msgDate = new Date(timestamp);
  const today = new Date();
  const isToday = msgDate.toDateString() === today.toDateString();
  const isSameYear = msgDate.getFullYear() === today.getFullYear();
  const timeStr = msgDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  if (isToday) {
    return timeStr;
  }

  if (isSameYear) {
    const dateStr = msgDate.toLocaleDateString([], { month: 'short', day: 'numeric' });
    return `${dateStr}, ${timeStr}`;
  }

  const dateStr = msgDate.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
  return `${dateStr}, ${timeStr}`;
}
